import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import * as L from 'leaflet';

@Component({
  selector: 'app-live-tracking',
  templateUrl: './live-tracking.component.html',
  styleUrl: './live-tracking.component.scss',
  standalone: false
})
export class LiveTrackingComponent {
  fireStations: any[] = [];
  vehicles: any[] = [];
  loading = false;
  submitting = false;
  filteredVehicles: any[] = [];
  
  map: any;
  incidentMarker: any;
  fireStationMarkers: any[] = [];
  vehicleMarkers: any[] = [];
  locationInterval: any;
  
  

  
  constructor(
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    // this.loadFireStations();
    this.loadVehicles();
    
    // Set up 15-second interval to refresh vehicle data
    this.locationInterval = setInterval(() => {
      this.loadVehicles();
    }, 15000); // 15 seconds
  }

  ngOnDestroy(): void {
    if (this.locationInterval) {
      clearInterval(this.locationInterval);
    }
  }

  ngAfterViewInit(): void {
    this.initializeMap();
  
  }

  private initializeMap(): void {
    // Initialize map centered on a default location (will be updated when incident loads)
    this.map = L.map('assignment-map').setView([22.7184, 75.8554], 15);
    
    // Google Maps basemap - Replace YOUR_API_KEY with your actual Google Maps API key
    L.tileLayer('https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      attribution: '© Google Maps',
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    }).addTo(this.map);
  }


  private loadFireStations(): void {
    this.apiService.get('/fire-stations').subscribe({
      next: (response: any) => {
        this.fireStations = response.data || response;
        this.checkAndUpdateMap();
      },
      error: (error) => {
        console.error('Error loading fire stations:', error);
      }
    });
  }

  private loadVehicles(): void {
    this.apiService.get('/fims-vehicles').subscribe({
      next: (response: any) => {
        this.vehicles = response.data || response;
        this.checkAndUpdateMap();
       this.loading = false;

      },
      error: (error) => {
        console.error('Error loading vehicles:', error);
      }
    });
  }

  private checkAndUpdateMap(): void {
    // Update map only when both fire stations and vehicles are loaded
    if (this.fireStations.length > 0 || this.vehicles.length > 0) {
      this.updateMap();
    }
  }

  private updateMap(): void {
    if (!this.map) return;
    this.clearMarkers();

    // Add fire station markers
    this.fireStations.forEach(station => {
      if (station.latitude && station.longitude) {
        const stationIcon = L.divIcon({
          html: '<img src="assets/icons/fire-station-marker.svg" style="width: 40px; height: 40px;" alt="Fire Station">',
          iconSize: [40, 40],
          className: 'custom-div-icon',
          iconAnchor: [20, 20],
          popupAnchor: [0, -20]
        });

        const marker = L.marker(
          [parseFloat(station.latitude), parseFloat(station.longitude)],
          { icon: stationIcon }
        ).addTo(this.map);

        marker.bindPopup(`
          <strong>${station.name}</strong><br>
          ${station.address}
        `);

        this.fireStationMarkers.push(marker);
      }
    });

    // Add free vehicle markers
    this.vehicles.forEach(vehicle => {
      // Use fire station coordinates as vehicle location
      if (vehicle.fireStation?.latitude && vehicle.fireStation?.longitude) {
        const vehicleIcon = L.divIcon({
          html: '<img src="assets/icons/vehicle-marker.svg" style="width: 36px; height: 36px;" alt="Vehicle">',
          iconSize: [36, 36],
          className: 'custom-div-icon',
          iconAnchor: [18, 18],
          popupAnchor: [0, -18]
        });

        const marker = L.marker(
          [parseFloat(vehicle.fireStation.latitude), parseFloat(vehicle.fireStation.longitude)],
          { icon: vehicleIcon }
        ).addTo(this.map);

        // Create enhanced popup with vehicle information
        const popupContent = `
          <div style="min-width: 280px;">
            <h6 style="margin-bottom: 10px; color: #B71C1C;">${vehicle.vehicleNo}</h6>
            <p style="margin: 5px 0;"><strong>Type:</strong> ${vehicle.vehicleType}</p>
            <p style="margin: 5px 0;"><strong>Make:</strong> ${vehicle.make || 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Model:</strong> ${vehicle.model || 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Capacity:</strong> ${vehicle.capacity ? vehicle.capacity + 'L' : 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Fire Station:</strong> ${vehicle.fireStation?.name || 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Station Code:</strong> ${vehicle.fireStation?.code || 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Contact:</strong> ${vehicle.fireStation?.contactNumber || 'N/A'}</p>
            <p style="margin: 5px 0;"><strong>Status:</strong> <span class="badge bg-success">Active</span></p>
          </div>
        `;

        marker.bindPopup(popupContent);

        this.vehicleMarkers.push(marker);
      }
    });

    const group = new L.FeatureGroup([
      ...this.fireStationMarkers,
      ...this.vehicleMarkers
    ]);

    if (group.getLayers().length > 0) {
      this.map.fitBounds(group.getBounds().pad(0.1));
    }
  }

  private clearMarkers(): void {
    this.fireStationMarkers.forEach(marker => this.map.removeLayer(marker));
    this.vehicleMarkers.forEach(marker => this.map.removeLayer(marker));
    this.fireStationMarkers = [];
    this.vehicleMarkers = [];
  }
}








